import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { UserComponent } from 'app/layout/common/user/user.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@NgModule({
  declarations: [UserComponent],
  imports: [
    MatButtonModule,
    MatIconModule,
    RouterModule,
    OverlayPanelModule,
    CommonModule,
  ],
  exports: [UserComponent],
})
export class UserModule {}
